const isString = (possibleString: any): possibleString is string =>
	Object.prototype.toString.call(possibleString) === '[object String]';

const getQueryParamsObj = (): URLSearchParams => {
	const queryString = window.location.search;
	return new URLSearchParams(queryString);
};

const hasQueryParam = (key: string): boolean => {
	return getQueryParamsObj().has(key);
};

const getQueryParam = (key: string): string | null => {
	const paramsObj = getQueryParamsObj().get(key);
	if (isString(paramsObj)) return decodeURI(paramsObj);
	return null;
};

const getHashParamsObj = (): URLSearchParams => {
	const queryString = window.location.hash.replace('#', '&');
	return new URLSearchParams(queryString);
};

const hasHashParam = (key: string): boolean => {
	return getHashParamsObj().has(key);
};

const getHashParam = (key: string): string | null => {
	const paramsObj = getHashParamsObj().get(key);
	if (isString(paramsObj)) return decodeURI(paramsObj);
	return null;
};

const clearAllParams = (): string => {
	history.replaceState(null, '', window.location.pathname);
	window.location.hash = '';
	return location.href;
};

const checkUrlQueryParams = (params: string[]): boolean => {
	return params.every(param => {
		return hasQueryParam(param);
	});
};

const checkUrlHashParams = (params: string[]): boolean => {
	return params.every(param => {
		return hasHashParam(param);
	});
};

const isCookieEnabled = (): boolean => {
	if (navigator.cookieEnabled) return true;

	// setea y borra una cookie para navegadores antiguos que no tienen el
	// api navigator
	document.cookie = 'cookietest=1';
	const isSetted = document.cookie.includes('cookietest=');
	// delete cookie
	document.cookie = 'cookietest=1; expires=Thu, 01-Jan-1970 00:00:01 GMT';

	return isSetted;
};

const isSessionStorageAvailable = (): boolean => {
	return typeof sessionStorage !== 'undefined';
};

const isLocalStorageAvailable = (): boolean => {
	return typeof localStorage !== 'undefined';
};

const blockSpecialChars = (e: any) => {
	e.target.value = e.target.value.replace(
			/[&#¢∞+≠÷”\-–¡¿()$~%@.'":*=/·!ªº_?<>^{}|½¬[\]]/g,
		''
	);
	return e;
};

const blockSpecialCharsSpace = (e: any) => {
	e.target.value = e.target.value.replace(
			/[\s&#¢∞+≠÷”\-–¡¿()$~%@.'":*=/·!ªº_?<>^{}|½¬[\]]/g,
		''
	);
	return e;
};

const blockSpecialCharsAdressForm = (e: any) => {
	e.target.value = e.target.value.replace(
			/[&#¢∞+≠÷”¡¿,()$~%@.":*=/·!ªº_?<>^{}|½¬[\]]/g,
		''
	);
	return e;
};

const blockSpecialCharsNumDoc = (e: any) => {
	e.target.value = e.target.value.replace(
			/[&#¢∞+≠÷”¡¿()$~%@'":*=/·!ªº_?<>^{}|½¬[\]]/g,
		''
	);
	return e;
};

const blockSpecialCharsNrt = (e: any) => {
	const pref = 'F-';
	let suf = e.target.value.replace(pref, '');
	// Eliminamos caracteres especiales
		suf = suf.replace(/[&#¢∞+≠÷”\-–¡¿()$~%@.'":*=/·!ªº_?<>^{}|½¬[\]]/g, '');
	e.target.value = pref + suf;
	return e;
};

const b64toBlob = (base64: string, type = 'application/octet-stream') =>
	fetch(`data:${type};base64,${base64}`).then(res => res.blob());

const formatBlankSpaces = (element: string) => {
	return element.replace(/\s+/g, ' ').trim();
};

const getCookieValue = (name: string): string | null => {
	const cookie = document.cookie
		.split(';')
		.find(cookie => cookie.trim().startsWith(`${name}=`));

	return cookie ? cookie.split('=')[1] : null;
};

const getCurrentLanguage = (): string => {
	const cookieLang = getCookieValue('lang');
	const localStorageLang = localStorage.getItem('lang');

	return cookieLang || localStorageLang || 'es';
};

export {
	getQueryParamsObj,
	hasQueryParam,
	getQueryParam,
	clearAllParams,
	checkUrlQueryParams,
	getHashParamsObj,
	hasHashParam,
	getHashParam,
	checkUrlHashParams,
	isCookieEnabled,
	isSessionStorageAvailable,
	isLocalStorageAvailable,
	isString,
	blockSpecialChars,
	blockSpecialCharsNrt,
	blockSpecialCharsNumDoc,
	blockSpecialCharsSpace,
	b64toBlob,
	blockSpecialCharsAdressForm,
	formatBlankSpaces,
	getCurrentLanguage,
};
